<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Card from "../UiCommenCard.svelte";
  import data from "../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
  import { Heading, Headings, HeadingsExample, HeadingsMessage, SubHeading } from "../../../utils/Constant/Constant";
</script>

<Col sm="12">
  <Card cardHeader2props="pb-0" CardBodyprops="typography">
    <div slot="customHeader2">
      <h5>{Headings}</h5>
      <span>{@html HeadingsMessage}</span>
    </div>
    <div slot="contentbody">
      <Row>
        <Col sm="12" xl="6">
          <h1>{HeadingsExample} 1</h1>
          <h2>{HeadingsExample} 2</h2>
          <h3>{HeadingsExample} 3</h3>
          <h4>{HeadingsExample} 4</h4>
          <h5>{HeadingsExample} 5</h5>
          <h6>{HeadingsExample} 6</h6>
        </Col>
        <Col sm="12" xl="6">
          <p class="h1 txt-primary">{Heading} 1<small>{SubHeading}</small></p>
          {#each data.Headings as fontItem}
            <p class={fontItem.class}>{fontItem.header}<small>{SubHeading}</small></p>
          {/each}
        </Col>
      </Row>
    </div>
  </Card>
</Col>
